import { ModeratedTaskFormat, SessionFormat } from '@app/api';

import distanceCallIllustration from '@app/illu/Large/VideoCall.svg';
import phoneCallIllustration from '@app/illu/Large/PhoneCall.svg';
import physicalIllustration from '@app/illu/Large/Physical.svg';
import inParticipantPlaceIllustration from '@app/illu/Large/Location.svg';

export const getFormatIllustration = (
  format: SessionFormat | ModeratedTaskFormat,
) => {
  switch (format) {
    case SessionFormat.PHONE_CALL:
    case ModeratedTaskFormat.PHONE_CALL:
      return phoneCallIllustration;
    case SessionFormat.VIDEO_CALL:
    case ModeratedTaskFormat.VIDEO_CALL:
      return distanceCallIllustration;
    case SessionFormat.IN_PARTICIPANT_PLACE:
      return inParticipantPlaceIllustration;
    case SessionFormat.PHYSICAL_MEETING:
    case ModeratedTaskFormat.PHYSICAL_MEETING:
    default:
      return physicalIllustration;
  }
};
